<template>
  <v-row justify="center" align="center">
    <v-col cols="12" align="center">
      <v-card class="padding-10">
        <v-card-title>Add Guest Parking</v-card-title>
        <v-card-text class="padding-10">
          <v-form ref="form" lazy-validation>
            <v-row wrap>
              <v-text-field
                v-model="guest.unit"
                label="Unit"
                type="number"
                outlined
                color="accent"
                required
                :rules="requiredRules"
              ></v-text-field>
              <v-text-field
                v-model="guest.licensePlate"
                label="License Plate"
                outlined
                color="accent"
                required
                :rules="requiredRules"
              ></v-text-field>
              <v-text-field
                v-model="guest.model"
                label="Model"
                outlined
                color="accent"
                required
                :rules="requiredRules"
              ></v-text-field>
              <v-text-field
                v-model="guest.color"
                label="Color"
                outlined
                color="accent"
                required
                :rules="requiredRules"
              ></v-text-field>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="guest.expirationDate"
                    outlined
                    label="Expiration Date"
                    hint="Only applies if guest is staying longer than 24 hours"
                    persistent-hint
                    append-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="guest.expirationDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-row>
            <v-alert
              v-if="alert.message != ''"
              :type="alert.type"
              :color="alert.type"
              outlined
            >{{alert.message}}</v-alert>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" text @click="addGuest">Submit</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" align="center">
      <v-card>
        <v-card-title>
          Active Visitors
          <v-spacer></v-spacer>
          <v-text-field
            v-model="activeSearch"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="activeGuests" :search="activeSearch"></v-data-table>
      </v-card>
    </v-col>
    <v-col cols="12" align="center">
      <v-card>
        <v-card-title>
          Visitors Log
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="guests" :search="search"></v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { guestsRef } from "../firebaseApp";

export default {
  data: () => ({
    menu: false,
    modal: false,
    menu2: false,
    guest: {
      unit: "",
      licensePlate: "",
      model: "",
      color: "",
      dateAdded: "",
      expirationDate: ""
    },
    guests: [],
    activeGuests: [],
    alert: {
      type: "",
      message: ""
    },
    requiredRules: [v => !!v || "Required"],
    search: "",
    activeSearch: "",
    headers: [
      {
        text: "Unit",
        align: "left",
        sortable: false,
        value: "unit"
      },
      { text: "License Plate", value: "licensePlate" },
      { text: "Model", value: "model" },
      { text: "Color", value: "color" },
      { text: "Date", value: "dateAdded" },
      { text: "Expires on ", value: "expirationDate" }
    ]
  }),
  methods: {
    addGuest() {
      if (this.$refs.form.validate()) {
        this.guest.dateAdded = Date.now();
        this.guest.expirationDate = Date.parse(this.guest.expirationDate);
        if (this.isUnique("licensePlate")) {
          guestsRef.push(this.guest).key;
          this.alert.message =
            this.guest.licensePlate + " has been successfully added";
          this.$refs.form.reset();
          this.alert.type = "success";
        } else {
          this.alert.type = "error";
          this.alert.message =
            "A guest has already been registered with the same license plate for today.";
        }
      }
    },
    isUnique(prop) {
      let value = this.guest[prop];
      let isUnique = true;
      this.guests.forEach(existingGuest => {
        if (
          value == existingGuest[prop] &&
          !this.isOver24Hours(existingGuest.dateAdded)
        ) {
          isUnique = false;
        }
      });
      return isUnique;
    },
    isOver24Hours(date) {
      let oneDay = new Date(new Date(date).getTime() + 1 * 24 * 60 * 60 * 1000),
        today = new Date();
      if (oneDay >= today) {
        return false;
      } else if (oneDay < today) {
        return true;
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    loadGuests() {
      let guests = [];
      this.guests = [];
      guestsRef.on("value", snap => {
        snap.forEach(guest => {
          let mem = {};
          mem = guest.val();
          mem.id = guest.key;
          mem.dateAdded =
            guest.val().dateAdded == undefined
              ? ""
              : new Date(guest.val().dateAdded).toLocaleDateString();
          mem.expirationDate =
            guest.val().expirationDate == undefined
              ? ""
              : new Date(guest.val().expirationDate).toLocaleDateString();
          guests.push(mem);
        });
        if (guests.length) {
          this.guests = guests;
          this.loadActiveGuests();
        }
      });
    },
    loadActiveGuests() {
      let uniqueVisitors = [];
      let visitors = this.guests;
      uniqueVisitors = Array.from(
        new Set(visitors.map(a => a.licensePlate))
      ).map(licensePlate => {
        return visitors.find(a => a.licensePlate === licensePlate);
      });
      let activeVisitors = [];
      uniqueVisitors.forEach(visitor => {
        if (
          visitor.expirationDate != undefined &&
          visitor.expirationDate != ""
        ) {
          let today = new Date();
          if (Date.parse(today) < Date.parse(visitor.expirationDate)) {
            activeVisitors.push(visitor);
          }
        } else if (!this.isOver24Hours(visitor.dateAdded)) {
          activeVisitors.push(visitor);
        }
      });
      this.activeGuests = activeVisitors;
    }
  },
  mounted() {
    this.loadGuests();
  }
};
</script>